import styled from "@emotion/styled";
import XIcon from "../../../../img/x.svg?react";
import { Spacer } from "components/general/Spacer/Spacer";
import { Text } from "components/general/Text";
import { useMemo } from "react";
import { getShareTweetLink } from "utils/shareTradeUtils";
import { Hash } from "viem";
import { useTokenListByChain } from "../../../../hooks/useTokenListByChain";
import { TokenList } from "../../../../store/global/getAllTokenLists";

interface ShareTradeBtnProps {
  sellTokenSymbols: Array<Hash>;
  buyTokenSymbols: Array<Hash>;
  tokenListOverride?: TokenList;
}

export const ShareTradeBtn = ({
  sellTokenSymbols,
  buyTokenSymbols,
  tokenListOverride,
}: ShareTradeBtnProps) => {
  const tokenList = useTokenListByChain();
  const tokenListToUse = tokenListOverride || tokenList;
  const shareTweetLink = useMemo(
    () => getShareTweetLink(sellTokenSymbols, buyTokenSymbols, tokenListToUse),
    [buyTokenSymbols, sellTokenSymbols, tokenListToUse]
  );

  return (
    <Button onClick={() => window.open(shareTweetLink, "_blank", "noreferrer")}>
      <XIcon width={20} height={20} />
      <Spacer width="6px" />
      <Text textStyle="Button" size="Medium">
        Share my trade
      </Text>
    </Button>
  );
};

// Sub-components

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 14px;
  padding: 13px 16px 13px 10px;
  color: ${props => props.theme.button.tertiary.text.default};
  background-color: ${props => props.theme.button.tertiary.surface.default};
  transition: background-color 150ms linear;

  &:hover {
    background-color: ${props => props.theme.button.tertiary.surface.hover};
    color: ${props => props.theme.button.tertiary.text.hover};
  }
`;
